(function () {
    'use strict';

    angular
        .module('app.user')
        .component('ubStepWizardTypes', {
            bindings: {
                editMode: '<',
                settings: '<',
                model: '<',
                selectableUserTypes: '<',
                existingRoles: '<',
                onValidationChanged: '&',
                onUserTypeChanged: '&'
            },
            controller: UserOnboardingStepWizardTypes,
            controllerAs: 'vm',
            templateUrl: 'app/user/dashboard/onboard/wizard/step-types/user.onboard.wizard.types.html'
        });

    /*jshint -W071, -W072 */
    /* @ngInject */
    function UserOnboardingStepWizardTypes($q, autocarSiteService,
        dialogService) {
        var vm = this;

        var config = {
            Buttons: [
                { Text: 'Dont Override', isConfirmation: true, IsPrimary: true ,OnClick: OnDontOverrideClicked },
                { Text: 'Override', isConfirmation: true, IsPrimary: true, OnClick: OnOverrideClicked }
            ]
        };
        vm.$onInit = onInit;

        vm.loading = false;

        vm.override = false;
        vm.userRole = null;
        vm.autocarSites = [];

        vm.validate = validate;
        vm.getSiteDescription = getSiteDescription;
        vm.onUserTypeDropDownChanged = onUserTypeDropDownChanged;

        function onInit() {
            var promises = [getAutocarSites()];

            $q.all(promises).then(function () {
                vm.model.TempUserTypeId = vm.model.UserTypeId;
                validate();
            });
        }

        function OnDontOverrideClicked() {
            vm.override = false;
        }

        function OnOverrideClicked() {
            vm.override = true;
        }

        function getAutocarSites() {
            var promise = autocarSiteService.getSites();

            return promise.then(
                function (result) {
                    vm.autocarSites = result.data.map(
                        function (s) {
                            return ({
                                SiteId: s.SiteId,
                                Description: s.Code + ' - ' + s.Description
                            });
                        });

                    return vm.autocarSites;
                });
        }

        function onUserTypeDropDownChanged(userType) {
            if (vm.editMode) {
                dialogService.custom('Confirm User Type change',
                    'You have selected a new user type for this user. You ' +
                    'can choose to override the existing application permissions ' +
                    'using the new user types configuration, or you can choose to ' +
                    'not override the existing application permissions.', config).then(function () {
                        userTypeChanged(userType);
                    }, function () {
                        vm.model.TempUserTypeId = vm.model.UserTypeId;
                    });              
            } else {
                userTypeChanged(userType);
            }
        }

        function userTypeChanged(userType) {
            vm.model = angular.extend(vm.model, { IsADUser: userType.IsADUser, UserTypeId: userType.UserTypeId });

            if (!userType.IsADUser) {
                vm.model.AutocarSites = [];
            }

            validate();
            vm.onUserTypeChanged({ userType: userType, override: vm.override });
        }

        function validate() {
            var validationStatus = false;

            validationStatus = (vm.model.IsADUser ? vm.model.AutocarSites.length > 0 : true) && vm.model.UserTypeId > 0;

            vm.onValidationChanged({ isValid: validationStatus });
        }

        function getSiteDescription(siteId) {
            var site = _.where(vm.autocarSites, { SiteId: siteId });
            if (site.length > 0) {
                return site[0].Description;
            }

            return null;
        }
    }

})();
